import React, { lazy } from "react";
import LanguageIcon from "@mui/icons-material/Language";
import saga from "./saga";

const SitesPage = lazy(() => import("./SitesPage"));
const SiteDetailPage = lazy(() => import("./SiteDetailPage"));
const SecurityPage = lazy(() => import("./SecurityPage"));
const AdminPanel = lazy(() => import("./AdminPanel"));
const FleetPage = lazy(() => import("./FleetPage"));

const cwReports = {
    id: "cw-reports",
    name: "CW Reports",
    nav: [{ label: "Sites", path: "/plugins/cw-reports", icon: LanguageIcon }],
    routes: [
        { path: "/plugins/cw-reports", element: <SitesPage /> },
        { path: "/plugins/cw-reports/sites/:sid", element: <SiteDetailPage /> },
        { path: "/plugins/cw-reports/security", element: <SecurityPage /> },
    ],
    internal: {
        nav: [{ label: "Client Sites", path: "/plugins/cw-reports/fleet", icon: LanguageIcon }],
        routes: [
            { path: "/plugins/cw-reports/fleet", element: <FleetPage /> },
            { path: "/plugins/cw-reports/fleet/security", element: <SecurityPage fleet /> },
            { path: "/plugins/cw-reports/fleet/:clientId/sites/:sid", element: <SiteDetailPage /> },
            { path: "/plugins/cw-reports/fleet/:clientId/security", element: <SecurityPage /> },
        ],
    },
    saga,
    admin: <AdminPanel />,
};

export default cwReports;
